var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 15.8334H10.833C13.19 15.8334 14.3685 15.8334 15.1008 15.1011C15.833 14.3689 15.833 13.1904 15.833 10.8334V8.33337M15.833 8.33337C16.4165 8.33337 17.5068 9.99529 17.9163 10.4167M15.833 8.33337C15.2495 8.33337 14.1593 9.99529 13.7497 10.4167",
    stroke: "#4A5264",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 5.83337V14.1667",
    stroke: "#4A5264",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5.83333C5.08714 5.83333 5.83333 5.08714 5.83333 4.16667C5.83333 3.24619 5.08714 2.5 4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 3.24619 5.83333 4.16667 5.83333Z",
    stroke: "#4A5264",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 5.83333C16.7541 5.83333 17.5003 5.08714 17.5003 4.16667C17.5003 3.24619 16.7541 2.5 15.8337 2.5C14.9132 2.5 14.167 3.24619 14.167 4.16667C14.167 5.08714 14.9132 5.83333 15.8337 5.83333Z",
    stroke: "#4A5264",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.5C5.08714 17.5 5.83333 16.7538 5.83333 15.8333C5.83333 14.9128 5.08714 14.1666 4.16667 14.1666C3.24619 14.1666 2.5 14.9128 2.5 15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5Z",
    stroke: "#4A5264",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.f01807af0107ee2f95f31879940b8a90.svg";
export { ForwardRef as ReactComponent };